import React from 'react';
import { width } from 'styled-system';
import { styled } from '~ui-kit/styled-components';
import { theme } from '~ui-kit/theme';
import { SectionProgressBarItemModel } from './models/section-progress-bar-item-model';

interface SectionProgressBarItemProps {
  item: SectionProgressBarItemModel;
  isActive: boolean;
  isDone: boolean;
  isClickable: boolean;
  onClick?: (item: SectionProgressBarItemModel) => void;
}

export function SectionProgressBarItem({ item, isActive, isDone, isClickable, onClick }: SectionProgressBarItemProps) {
  return (
    <ItemContainer $isActive={isActive} $isDone={isDone} $isClickable={isClickable} onClick={() => onClick?.(item)}>
      <div className="item-label">{item.label}</div>
      <div className="item-indicator"></div>
    </ItemContainer>
  );
}

const ItemContainer = styled.div<{ $isActive: boolean; $isDone: boolean; $isClickable: boolean }>`
  opacity: ${(props) => (props.$isActive || !props.$isDone ? '1' : '0.5')};
  flex: 1 1 120px;
  ${(props) => props.$isClickable && 'cursor: pointer;'}
  ${width({ width: ['100%', '100%', '120px'] })}

  .item-label {
    color: ${(props) => (props.$isActive || props.$isDone ? theme.colors.primary : theme.colors.secondaryDark)};
    font-size: 14px;
    font-weight: 500;
    line-height: 21px;
    text-align: center;
    white-space: nowrap;
    margin: 0 5px;
  }

  .item-indicator {
    height: 6px;
    background: ${(props) =>
      props.$isActive || props.$isDone ? theme.colors.primary : theme.colors.sectionProgressBarUnreached};
  }
`;
